'use client';

import { isIOS } from '@wwe-portal/web/utils/platform/os';
import { isAndroid } from '@wwe-portal/web/utils/platform/os';
import { IcoMoonIcon } from '@wwe-portal/ui/components/icons';
import { useResponsive } from '@wwe-portal/ui/hooks/use-responsive';
import { FC, ReactNode } from 'react';

import {
  BACK_TO_GAME_ANDROID_URL,
  BACK_TO_GAME_IOS_URL,
} from '@wwe-portal/web/utils/config';
import { sendUserClickBackToGame } from '@wwe-portal/web/libs/analytics/global';
import { SeperateLine } from '@wwe-portal/ui/layout/app/left-sidebar/seperate-line';

const getLink = () => {
  if (isAndroid()) return BACK_TO_GAME_ANDROID_URL;
  if (isIOS()) return BACK_TO_GAME_IOS_URL;
  return null;
};

export const BackToGameLink: FC<{
  children: ReactNode;
  fallback?: ReactNode;
}> = ({ children, fallback = null }) => {
  const { isHydrated, xl: isDesktop } = useResponsive();
  if (!isHydrated) return null;
  const href = getLink();
  if (!href || isDesktop) return fallback;
  return (
    <a href={href} className="w-full" onClick={() => sendUserClickBackToGame()}>
      {children}
    </a>
  );
};

export const BackToGameButton = () => {
  return (
    <BackToGameLink>
      <div className="-mx-5 py-5">
        <SeperateLine />
      </div>
      <button className="rounded-6 flex h-[50px] w-full flex-row items-center justify-center gap-2 border border-[#00CED8] bg-gradient-to-b from-[#006DDA] to-[#0033A8] text-white">
        <IcoMoonIcon iconName="gamepad" className="h-5 w-5" />{' '}
        <span className="text-sm">BACK TO GAME</span>
      </button>
    </BackToGameLink>
  );
};
